export default {
    globalSnackbar: {
        show: false,
        text: '',
        color: '',
    }
}